var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Host-White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Host-White",
    clipPath: "url(#clip-Host-White)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M12.754-26.144a.44.44,0,0,1,.133-.323.44.44,0,0,1,.323-.133h5.4a.44.44,0,0,1,.323.133.44.44,0,0,1,.133.323V-.456a.44.44,0,0,1-.133.323A.44.44,0,0,1,18.606,0h-5.4a.44.44,0,0,1-.323-.133.44.44,0,0,1-.133-.323v-9.956a.168.168,0,0,0-.048-.142.168.168,0,0,0-.142-.048H7.828a.168.168,0,0,0-.142.048.168.168,0,0,0-.048.142V-.456A.44.44,0,0,1,7.5-.133.44.44,0,0,1,7.182,0h-5.4a.44.44,0,0,1-.323-.133A.44.44,0,0,1,1.33-.456V-26.144a.44.44,0,0,1,.133-.323.44.44,0,0,1,.323-.133h5.4a.44.44,0,0,1,.323.133.44.44,0,0,1,.133.323v9.918a.168.168,0,0,0,.048.142.168.168,0,0,0,.142.048h4.736a.168.168,0,0,0,.142-.048.168.168,0,0,0,.048-.142Z",
    transform: "translate(7.802 31.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostWhite);
export default __webpack_public_path__ + "static/media/Host-White.1a08f06f3825c672998e9a30a8aede6d.svg";
export { ForwardRef as ReactComponent };